<template>
  <div class="cx-slider verticallyCenter">
    <div v-if="displayLabel" class="fs13 mr16 slider-title" :style="titleStyle">{{ displayLabel }}</div>
    <div :class="`font-arrangement-btn height${height}`" v-if="extraConfig.showToolTip">
      <span class="btn-active" :style="getTranslate"></span>
      <el-tooltip
        v-for="(option, index) in usedOptions"
        :key="index"
        slot="label"
        class="item"
        effect="dark"
        :content="option.label"
        placement="top-end"
        :open-delay="1000"
      >
        <span
          class="fs13"
          :class="[slideDistance == option.value ? 'select pd2' : 'pd2', option.iconClass]"
          @click="changeValue(option.value)"
          >{{ option.iconClass ? "" : option.title }}</span
        >
      </el-tooltip>
    </div>
    <div :class="`font-arrangement-btn height${height}`" v-else>
      <span class="btn-active" :style="getTranslate"></span>
      <span
        v-for="(option, index) in usedOptions"
        :key="index"
        class="fs13"
        :class="[slideDistance == option.value ? 'select pd2' : 'pd2', option.iconClass]"
        @click="changeValue(option.value)"
        >{{ option.title }}</span
      >
    </div>
  </div>
</template>

<script>
import "modules/common.css"
export default {
  name: "cx-slider",
  props: {
    defaultValue: undefined,
    extraConfig: undefined,
    config: undefined,
    label: {
      type: String,
      required: false
    },
    title: String,
    options: {
      type: [Array, Object],
      required: false
    },
    showToolTip: {
      type: Boolean,
      default: false
    },
    height: {
      type: Number,
      default: 30
    }
  },
  data() {
    return {
      translate: 0,
      sliderWidth: 0
    }
  },
  watch: {
    options() {
      this.sliderWidth = `calc((100% - 6px) / ${this.options.length || 1})`
      this.translate = 0
    }
  },
  computed: {

    titleStyle() {
      return this?.extraConfig?.titleStyle || {}
    },
    displayLabel() {
      return this.label || this.title || this?.extraConfig?.sliderTitle
    },
    slideDistance: {
      get() {
        let index = this.usedOptions.findIndex(item => item.value === (this.config || this.defaultValue))
        this.translate = `${100 * index}%`
        return this.config ?? this.defaultValue
      },
      set(val) {
        this.$emit("update:config", val)
      }
    },
    getTranslate() {
      return {
        width: this.sliderWidth,
        transform: `translateX(${this.translate})`
      }
    },
    usedOptions() {
      if (this.extraConfig.useType) {
        return this.sliderOptions[this.extraConfig.useType] || this.extraConfig.options
      }
      return this.extraConfig.options
    }
  },
  beforeCreate() {

    this.sliderOptions = {
      horizontalTextAlign: [
        {
          title: "左对齐",
          iconClass: "icon-portal-text-leftt1",
          icon: "icon-portal-text-leftt1",
          value: "left"
        },
        {
          title: "居中对齐",
          iconClass: "icon-portal-text-center1",
          icon: "icon-portal-text-center1",
          value: "center"
        },
        {
          title: "右对齐",
          iconClass: "icon-portal-text-right1",
          icon: "icon-portal-text-right1",
          value: "right"
        },
        {
          title: "两端对齐",
          iconClass: "icon-portal-text-both1",
          icon: "icon-portal-text-both1",
          value: "justify",
          type: "highLevel"
        }
      ],
      verticalTextAlign: [
        {
          title: "顶对齐",
          iconClass: "icon-portal-text-top-v",
          icon: "icon-portal-text-top-v",
          value: "left"
        },
        {
          title: "居中对齐",
          iconClass: "icon-portal-text-center-v",
          icon: "icon-portal-text-center-v",
          value: "center"
        },
        {
          title: "底对齐",
          iconClass: "icon-portal-text-bottom-v",
          icon: "icon-portal-text-bottom-v",
          value: "right"
        },
        {
          title: "两端对齐",
          iconClass: "icon-portal-text-both-v",
          icon: "icon-portal-text-both-v",
          value: "justify",
        }
      ],
      writingMode: [
        {
          title: "横排文字",
          value: "horizontal-tb",
          iconClass: "icon-portal-horizontal-text",
          icon: "icon-portal-horizontal-text",
        },
        {
          title: "竖排文字",
          value: "vertical-lr",
          iconClass: "icon-portal-text-down1",
          icon: "icon-portal-text-down1",
        }
      ],
    }
  },
  created() {
    this.sliderWidth = `calc((100% - 6px) / ${this.usedOptions.length || 1})`
    this.translate = 0
  },
  methods: {
    changeValue(val) {
      this.slideDistance = val
      this.$emit("update:config", val)
    }
  }
}
</script>

<style scoped>
.status-wrapper .slider-title {
  color: rgba(0, 0, 0, 0.4);
}
.font-arrangement-btn {
  flex: 1 1 0%;
}
.font-arrangement-btn.height32 {
  height: 32px;
}
.font-arrangement-btn.height32 span {
  height: 26px;
}
.font-arrangement-btn span::before {
  color: #717989;
  font-size: 16px;
}
.fs13 {
  font-size: 13px !important;
}
</style>
